"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../../openapi");
const Common = __importStar(require("../../common"));
const System = __importStar(require("../schema"));
const Brands = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.System.Brands.Spec';
/*
 * `routes/v2/api/system/brands/router.js`: every route is
 * `SysAdminUserRouteGuard`; the controller answers protocol v1 and validates
 * with express-validator (422). Mutations identify the brand with `?id=`.
 */
// Query structs intentionally have no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const IdQuery = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: 'Brand identifier' }),
});
const UniqueQuery = effect_1.Schema.Struct({
    name: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: 'Name to test' }),
});
const LogoUploadQuery = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: 'Brand identifier' }),
    ext: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'File extension of the logo; only the part before the first `.`, `-`, `+` or `,` is kept',
    }),
});
const BrandResponse = openapi_1.Response.Success(Brands.Brand).annotations({ description: 'The brand' });
const list = platform_1.HttpApiEndpoint.get('listBrands') `/list`
    .addSuccess(openapi_1.Response.Success(Brands.BrandList).annotations({ description: 'Every brand' }))
    .annotate(platform_1.OpenApi.Title, 'List Brands')
    .annotate(platform_1.OpenApi.Description, 'Returns every brand.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
const unique = platform_1.HttpApiEndpoint.get('isBrandUnique') `/unique`
    .setUrlParams(UniqueQuery)
    .addSuccess(openapi_1.Response.Success(System.NameUniqueness).annotations({
    description: 'Whether the name is unused',
}))
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Is Brand Unique')
    .annotate(platform_1.OpenApi.Description, 'Tells whether no brand has the given name.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
const get = platform_1.HttpApiEndpoint.get('getBrand') ``
    .setUrlParams(IdQuery)
    .addSuccess(BrandResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get Brand')
    .annotate(platform_1.OpenApi.Description, 'Returns one brand by id; 404 `Brand not found` when it does not exist.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
const create = platform_1.HttpApiEndpoint.post('createBrand') ``
    .setPayload(Brands.CreateBody)
    .addSuccess(openapi_1.Response.Success(Brands.Brand).annotations({ description: 'The created brand' }), {
    status: 201,
})
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Brand')
    .annotate(platform_1.OpenApi.Description, 'Creates a brand with a generated id and answers 201. A name already used by another brand is a 422. ' +
    'Known runtime quirk: `logo` is accepted but dropped, the repository create has no logo parameter; set it through the logo upload URL.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
const update = platform_1.HttpApiEndpoint.patch('updateBrand') ``
    .setUrlParams(IdQuery)
    .setPayload(Brands.UpdateBody)
    .addSuccess(BrandResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(Brands.EmptyBody)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update Brand')
    .annotate(platform_1.OpenApi.Description, 'Changes the given fields of a brand. An empty body is a 422; a name used by another brand is a 422; an unknown id is a 404. ' +
    'Known runtime quirk: this is not a partial update. Every field absent from the body is written as `undefined` over the stored brand, so every omitted field is wiped, `name` and `countries` included (a PATCH with only `color` leaves the brand with neither); send the full brand to keep them.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
const replace = platform_1.HttpApiEndpoint.put('replaceBrand') ``
    .setUrlParams(IdQuery)
    .setPayload(Brands.ReplaceBody)
    .addSuccess(BrandResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Replace Brand')
    .annotate(platform_1.OpenApi.Description, 'Replaces a brand. Omitted optional fields become null, and a null logo deletes the stored logo file. An unknown id is a 404.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
const remove = platform_1.HttpApiEndpoint.del('deleteBrand') ``
    .setUrlParams(IdQuery)
    .addSuccess(openapi_1.Response.noContent())
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete Brand')
    .annotate(platform_1.OpenApi.Description, 'Deletes a brand and its logo file and answers 204. An unknown id is a 404.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
const logoUploadUrl = platform_1.HttpApiEndpoint.get('getBrandLogoUploadUrl') `/logos/uploadURL`
    .setUrlParams(LogoUploadQuery)
    .addSuccess(openapi_1.Response.Success(Brands.LogoUploadUrl).annotations({ description: 'Pre-signed upload URL' }))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get Brand Logo Upload URL')
    .annotate(platform_1.OpenApi.Description, 'Returns a pre-signed URL to upload the logo of a brand with the given file extension. An unknown id is a 404.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
const deleteLogo = platform_1.HttpApiEndpoint.del('deleteBrandLogo') `/logos`
    .setUrlParams(IdQuery)
    .addSuccess(openapi_1.Response.EmptyData.annotations({ description: 'The logo was deleted' }))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete Brand Logo')
    .annotate(platform_1.OpenApi.Description, 'Deletes the stored logo file of a brand. An unknown id is a 404.')
    .pipe(Common.withSystemAdminGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.system.brands')
    .add(list)
    .add(unique)
    .add(get)
    .add(create)
    .add(update)
    .add(replace)
    .add(remove)
    .add(logoUploadUrl)
    .add(deleteLogo)
    .prefix('/system/brands')
    .annotate(platform_1.OpenApi.Title, 'System Brands')
    .annotate(platform_1.OpenApi.Description, 'Brands (device vendors) and their logos')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.System));
//# sourceMappingURL=spec.js.map